<template>
  <v-card>
    <v-toolbar dense extended elevation="1">
      <v-spacer />
      <v-toolbar-title> {{ device.name }} : スケジュール </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="close" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
      <template v-slot:extension>
        <v-btn fab text @click="prev()">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ calendarTitle }}
        </v-toolbar-title>
        <v-btn fab text @click="next()">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn outlined @click="setToday">
          今日
        </v-btn>
      </template>
    </v-toolbar>
    <v-card-text>
      <v-calendar
        :key="device ? `${device.id}_${events.length}` : 0"
        ref="calendar"
        v-model="focus"
        color="primary"
        type="month"
        :events="formattedEvents"
        :event-color="event => event.color"
        :now="today"
        :weekdays="weekday"
        @change="updateRange"
      >
        <template v-slot:event="{ event }">
          {{ getPlaylistName(event.playlist) }}
        </template>
      </v-calendar>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventFunctionsMixin } from '@/plugins/mixins'
import { fmt } from '@/plugins/datefns'

export default {
  name: 'DeviceUnitEditDialog',
  mixins: [eventFunctionsMixin],
  props: {
    device: {
      type: Object,
      required: true
    },
    events: {
      type: Array,
      required: true
    },
    // we should use device.config to determine the schedule
    devices: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    today: fmt(new Date(), 'yyyy-MM-dd'),
    focus: fmt(new Date(), 'yyyy-MM-dd'),
    start: null,
    end: null,

    weekday: [0, 1, 2, 3, 4, 5, 6],

    selectedEvent: {}
  }),
  computed: {
    ...mapGetters({
      playlists: 'playlists/getPlaylists'
    }),
    calendarTitle() {
      const { start, end } = this
      if (!start || !end) {
        return '--'
      }

      return fmt(new Date(start.date), 'yyyy/MM')
    },
    formattedEvents() {
      return this.events
        .filter(e => e.devices && e.devices.includes(this.device.id))
        .map(e => {
          e.start = new Date(e.startDate + ' ' + e.startTime)
          e.end = new Date(e.endDate + ' ' + e.endTime)
          return e
        })
    }
  },
  methods: {
    ...mapActions({
      bindPlaylistsRef: 'playlists/bindRef'
    }),
    close() {
      this.$emit('close')
    },
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    setToday() {
      this.focus = this.today
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    updateRange({ start, end }) {
      this.start = start
      this.end = end
    },
    getPlaylistName(id) {
      const playlist = this.playlists.find(p => p.id === id)
      return playlist ? playlist.name : '--'
    }
  },
  created() {
    this.bindPlaylistsRef()
  }
}
</script>
